













































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import SearchBar from '@/components/SearchBar.vue';
import Table from '@/components/Table.vue';
import UserService from '../services/user.service';
import { Action, Getter } from 'vuex-class';
import GenericButton from '@/components/GenericButton.vue';
import Dialog from '@/components/Dialog.vue';
import ConfirmButton from '@/components/ConfirmButton.vue';
import CancelButton from '@/components/CancelButton.vue';
import { copyToClipboard } from '@/classes/utils';
import ActionBarButton from '@/components/ActionBarButton.vue';

@Component({
  components: {
    ActionBarButton,
    CancelButton,
    ConfirmButton,
    Dialog,
    GenericButton,
    Table,
    SearchBar,
  },
})
export default class APIKeyList extends Vue {
  @Prop() private editUser: any;
  @Prop() private bus: any;
  @Prop({ default: null }) private searchString!: string;
  @Prop() private tableClasses!: string[];
  @Action private addToastErrorMessage: any;
  @Getter private login: any;


  private modalHeader: string = '';
  private modalBody: string = '';
  private showDisposeDialog: boolean = false;
  private handleModalConfirm: any = null;

  private users: any;
  private loading: boolean = false;
  private showDisposeAction: boolean = false;
  private showCheckboxes: boolean = true;
  private selectedRows: any[] = [];

  private tableData: any = {
    headers: [
      { text: 'Name', value: 'name', align: 'start', filterable: true },
      { text: 'Key Id', value: 'key_id', align: 'start', filterable: true },
      { text: '', value: 'api_token' },
      { text: 'Roles', value: 'roles' },
    ],
    total: 0,
    filters: {},
    distinctRows: {},
  };

  private copyToClipboard: (text: string) => boolean = copyToClipboard;

  public async getApiUsers() {
    const { users } = await UserService.getUsersForOrganisation(true);
    this.users = users;
    await this.populateUsers();
  }

  private async mounted() {
    await this.getApiUsers();
  }


  private async populateUsers() {
    return new Promise((resolve, reject) => {
      const rows: any[] = [];
      const data = this.users;

      data.forEach((row: any) => {
        if (!row.email.startsWith('api-user')) {
          return;
        }
        rows.push({
          id: row.id,
          name: row.first_name,
          key_id: row.api_token.split('.')[2],
          api_token: row.api_token,
          roles: row.roles.map((role: any) => role.name),
          sortedRoles: row.roles
            .map((role: any) => {
              return { name: role.name, id: role.id };
            })
            .sort((a: any, b: any) => a.id - b.id),
          roleIds: row.roles.map((role: any) => role.id),
        });
      });
      Vue.set(this.tableData, 'rows', rows);
      this.tableData
        ? resolve(this.tableData)
        : reject(this.addToastErrorMessage('Error resolving table data.'));
    });
  }

  private checkboxValuesChanged(checkboxValues: any[]) {
    this.selectedRows = checkboxValues;
    this.updateActionMenu();
  }

  private updateActionMenu() {
    this.showDisposeAction = !!this.selectedRows.length;
  }

  private async disposeKeys() {
    this.loading = true;
    try {
      await Promise.all(
        this.selectedRows.map(
          async (user: any): Promise<any> => {
            await UserService.removeUser(user.id);
          },
        ),
      );

      this.showDisposeAction = false;
      this.showDisposeDialog = false;
      this.selectedRows = [];
    } finally {
      this.loading = false;
    }

    await this.getApiUsers();
  }


  private getColor(role: any) {
    switch (role.name) {
      case 'Super Admin':
        return 'rgba(1,110,161,0.6)';
      case 'Organisation Admin':
        return '#016EA1';
      case 'User':
        return 'rgba(1,110,161,0.4)';
      default:
        return 'primary';
    }
  }
}
